var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"d-flex justify-content-between align-items-center",attrs:{"disabled":true}},[_vm._v(" "+_vm._s(_vm.$t('therms.app-version'))+" "),_c('span',{staticClass:"font-weight-bolder"},[_vm._v("v "),_c('app-version')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }